import { HTTP } from '@ionic-native/http/ngx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';


@Injectable({
  providedIn: 'root'
})
export class RequestService {

  pathZone = '_header_zone';
  constructor(private http: HTTP, private platfom: Platform, private httpWeb: HttpClient) {
  }

  async get(path: string, params, headers: object) {
    if (!this.platfom.is('cordova')) {
      const header = await this.headers(headers);
      return this.httpWeb.get(path, header).toPromise();
    } else {
      this.pathZone = path;
      await this.headerNative(headers);
      return this.http.get(path, params, this.http.getHeaders(this.pathZone)).then((response) => {
        return JSON.parse(response.data);
      }).catch((error) => {
        return error;
      });
    }
  }

  async getFull(path: string, params, headers: object) {
    if (!this.platfom.is('cordova')) {
      const header = await this.headers(headers);
      return this.httpWeb.get(path, header).toPromise();
    } else {
      this.pathZone = path;
      await this.headerNative(headers);
      return this.http.get(path, params, this.http.getHeaders(this.pathZone)).then((response) => {
        return response.data;
      }).catch((error) => {
        return error;
      });
    }
  }

  async post(path: string, params, headers: object, json?: boolean) {
    if (!this.platfom.is('cordova')) {
      return await this.httpWeb.post(path, params, this.headers(headers)).toPromise();
    } else {
      this.pathZone = path;
      await this.headerNative(headers);
      if (json) {
        await this.http.setDataSerializer('json');
      }
      return this.http.post(path, params, this.http.getHeaders(this.pathZone)).then((response) => {
        return JSON.parse(response.data);
        }).catch((error) => {
          console.log(error);
          return error;
        });
    }
  }

  async postDirectText(path: string, params, headersp: object, json?: boolean) {
    if (!this.platfom.is('cordova')) {
      return await this.httpWeb.post(path, params, this.headersText(headersp)).toPromise();
    } else {
      this.pathZone = path;
      await this.headerNative(headersp);
      if (json) {
        await this.http.setDataSerializer('json');
      }
      return this.http.post(path, params, this.http.getHeaders(this.pathZone)).then((response) => {
        return response;
        }).catch((error) => {
          console.log(error);
          return error;
        });
    }
  }

  async put(path: string, params, headers: object, json?: boolean) {
    if (!this.platfom.is('cordova')) {
      return await this.httpWeb.put(path, params, this.headers(headers)).toPromise();
    } else {
      this.pathZone = path;
      await this.headerNative(headers);
      if (json) {
        await this.http.setDataSerializer('json');
      }
      return this.http.put(path, params, this.http.getHeaders(this.pathZone)).then((response) => {
        return JSON.parse(response.data);
        }).catch((error) => {
          console.log(error);
          return error;
        });
    }
  }

  async delete(path: string, params, headers: object, json?: boolean) {
    if (!this.platfom.is('cordova')) {
      return await this.httpWeb.delete(path, params).toPromise();
    } else {
      this.pathZone = path;
      await this.headerNative(headers);
      if (json) {
        await this.http.setDataSerializer('json');
      }
      return this.http.delete(path, params, this.http.getHeaders(this.pathZone)).then((response) => {
        return JSON.parse(response.data);
        }).catch((error) => {
          return error;
        });
    }
  }

  protected headers(headers) {
    const httpOptions = {
      headers: new HttpHeaders(headers)
    };
    return httpOptions;
  }

  protected headersText(headers) {
    const httpOptions = Object.assign({
      headers: new HttpHeaders(headers),
      responseType: 'text'
    });
    return httpOptions;
  }

  async headerNative(header) {
    const entries = Object.entries(header);
    for (const head of entries) {
      const headerValue: any = head[1];
      this.http.setHeader(this.pathZone, head[0], headerValue);
    }
  }

}
